import gql from 'graphql-tag'

export const SET_STORY_VISIBILITY = gql`
  mutation setStoryNotVisibleToCoordinator($storyId: String!) {
    coordinator {
      update {
        story {
          setVisibleToCoordinator(visibleToCoordinator: false, storyId: $storyId) {
            success
          }
        }
      }
    }
  }
`
